(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v2"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.js-slideshow-v2').each(function(){
    var $slider = $(this);
    if ($slider.children().length > 1) {
      $slider.slick({
        autoplay: true,
        autoplaySpeed: 7000,
        arrows: true,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
